import React from 'react';

const LoadingBar = () => {
    return (
        <div className="w-full h-auto overflow-hidden">
            <div className="wa-loading-bar"></div>
        </div>
    );
};

export default LoadingBar;